/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum EntityTypeEnum {
    COUNTRIES = 'Countries/Regions',
    PARTNERS = 'Partners',
    SHIP_TO_PARTIES = 'Ship to parties',
    SUPPLYING_PACKING_PLANTS = 'Supplying packing plants',
    TRANSPORT_MODES = 'Transport modes',
    TRANSPORT_SERVICES = 'Transport services',
    LEAD_TIMES = 'Lead times',
    WARNINGS = 'Warnings',
    REASONS = 'Reasons',
    CLAIM_CODES = 'Claim codes',
    DECISION_CODES = 'Decision codes',
    ERROR_CODES = 'Error codes',
    BI_CATEGORIES = 'BI categories',
    TECHNICIANS_GROUPS = 'Technicians groups'
}
